<template>
  <div class="Investment-box">
    <div class="head-text">
      <h1>Value Added Services</h1>
    </div>
    <div class="card-box">
      <h4>Select your option</h4>
      <v-row>
        <template>
          <v-card v-for="valueAddedList in value_added_listing" :key="valueAddedList.id" class="mx-auto" outlined @click="subcategory(valueAddedList.id, valueAddedList.first_name+ ' '+valueAddedList.last_name)" :title="(valueAddedList.id >1) ? 'Coming soon':''" :disabled = "(valueAddedList.id == 1 || valueAddedList.id == 3 ) ? false:'disabled'"  > 
            <v-list-item three-line>
              <v-list-item-content class="cards">
                <div class="overlines">
                  <v-img  max-height="36" max-width="36" :src="webIcon + valueAddedList.web_icon"></v-img>
                </div>
                <div class="contents">
                  <div class="wraper">
                    <div class="name">
                      <span class="first-name">
                        <v-list-item-title>{{valueAddedList.first_name}}</v-list-item-title>
                      </span>
                      <span class="last-name">
                        <v-list-item-title>{{valueAddedList.last_name}}</v-list-item-title>
                      </span>
                    </div>
                    <v-list-item-title class="details">{{valueAddedList.text}}</v-list-item-title>
                  </div>
                </div>
                <v-btn text>
                  <v-img
                    max-height="30"
                    max-width="30"
                    src="https://dev-api.nimeya.ai/img/icons/forword_arrow.png"
                  >
                  </v-img>
                </v-btn>
              </v-list-item-content>              
            </v-list-item>
           <span style="color:red; margin-left:205px !important;" v-if="valueAddedList.id != 1 && valueAddedList.id != 3 "> Coming Soon!</span>
          </v-card>
        </template>
      </v-row>
    </div>
    <v-dialog v-model="goal_sure_info_dialog" width="550">
        <v-card class="secure-modal proceed-modal csv-file-modal">
          <v-card-title class="text-h5" >
            <h5>{{this.item_text}}</h5>
            <v-card-actions class="close-icon">
            <v-btn
              color="primary"
              text
              @click="goal_sure_info_dialog = false"
            >
              <v-img max-height="23" max-width="19" :src=" delete_pic" :lazy-src=" delete_pic"> </v-img>
            </v-btn>
          </v-card-actions>
          </v-card-title>
          <v-card-text>
            <div style="margin-top:10px;">
              <p>As individuals, we aspire in life. Many of these aspirations require careful financial planning such us sending kids to the best education institutes, enjoying a comfortable retirement, buying a vacation home, starting up a business etc.</p>
              <p>While we save & invest our hard-earned money to fulfil our aspirations, we do not have a handy tool to monitor how far we are towards achieving our aspirations and whether we need a course correction. </p>
              <p>With Nimeya’s GOALSURE you can now monitor your journey towards your aspirations and take corrective steps. With a set of dynamic calculators, we empower you to check how close you are towards fulfilling your life’s aspirations.</p>
            </div>  
          </v-card-text>
          <div class="button-box">
              <v-btn class="orange-btn" @click="close()">
                Cancel
              </v-btn>
              <v-btn class="orange-btn" @click="proceedGoalSure()">
                Proceed
              </v-btn>
          </div>  
        </v-card>
    </v-dialog>

    <v-dialog v-model="goal_sure_options_dialog" width="700">
      <v-card class="secure-modal proceed-modal">
        <v-card-title class="">
          <h5>Select your option to proceed</h5>
           <v-card-actions class="close-icon">
            <v-btn color="primary" text  @click="goal_sure_options_dialog = false">
              <v-img max-height="23" max-width="19" :src=" delete_pic" :lazy-src=" delete_pic"> </v-img>
            </v-btn>
          </v-card-actions>
        </v-card-title>
        <v-card-text>

         <div style="margin-top:10px;" class="goalSureOptions">
            <v-card
              v-for="option in goal_sure_options_list"
              :key="option.id"
              class="mx-auto"
              outlined
              @click="proceedGoalSureOption(option.id)"
              :title="(option.id >1) ? 'Coming soon':''"
              :disabled = "(option.id == 1 || option.id == 2 || option.id == 3 ) ? false:'disabled'"
             
            > 
              <v-list-item three-line>
                <v-list-item-content class="cards">
                  <div class="overlines">
                    <v-img
                      max-height="36"
                      max-width="36"
                      :src="webIcon + option.icon"
                    >
                    </v-img>
                  </div>
                  <div class="contents">
                    <div class="wraper">
                      <div class="name">
                        <span class="first-name">
                          <v-list-item-title><p><b>{{option.name}}</b><sub>METER</sub></p></v-list-item-title>
                        </span>
                      </div> 
                      <v-list-item-title class="details">{{
                        option.text
                      }}</v-list-item-title>
                    </div>
                  </div>
                  <v-btn text>
                    <v-img
                      max-height="30"
                      max-width="30"
                      src="https://dev-api.nimeya.ai/img/icons/forword_arrow.png"

                    >
                    </v-img>
                  </v-btn>
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>


    <v-dialog v-model="goal_sure_member_dialog" width="550" persistent>
      <v-card class="secure-modal proceed-modal csv-file-modal">
        <v-card-title class="text-h5" >
          <h5>Choose Member</h5>
          <v-card-actions class="close-icon">
          <v-btn
            color="primary"
            text
            @click="goalSureMemberDialog()"
          >
            <v-img max-height="23" max-width="19" :src=" delete_pic" :lazy-src=" delete_pic"> </v-img>
          </v-btn>
        </v-card-actions>
        </v-card-title>
        <form ref="form" id="riskometer_member_form" @submit.prevent lazy-validation>
          <v-card-text>
            <div style="margin-top:10px;">
              <strong><label class="goalsure_queston_label">Choose Member</label></strong>
              <v-select
                ref="member"
                name="member" 
                v-model="member"
                :items="member_items"
                item-value="id"
                item-text="name"
                placeholder="Select Member"
                @change = "chooseMember($event)"
                max-width="500px"
              ></v-select>
              <span style="color:red" v-if="showMemberError">Please Choose Member!</span>
            </div>  
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="blue-border-btn" text @click = "goalSureMemberDialog()" >Close</v-btn>
            <v-btn type="submit" style="background-color: #051d42 !important;color: #fff !important;height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;" @click="showQuestionCard()"  
            >Next</v-btn>
          </v-card-actions>
        </form>  
      </v-card>
    </v-dialog>

    <v-dialog v-model="goal_sure_quetion_dialog" width="800" persistent>
      <v-card class="secure-modal proceed-modal csv-file-modal">
        <v-card-title class="text-h5" >
          <span></span>
          <v-card-actions class="close-icon">
          <v-btn
            color="primary"
            text
            @click="goal_sure_quetion_dialog = false"
          >
            <v-img max-height="23" max-width="19" :src=" delete_pic" :lazy-src=" delete_pic"> </v-img>
          </v-btn>
        </v-card-actions>
        </v-card-title>
        <form ref="form" id="riskometer_form" @submit.prevent lazy-validation>
          <v-card-text>
            <div style="margin-top:10px;">
              <p  class="qus_note" style="color:#F19700 !important;">Note:- Check your Risk Tolerance level by answering 6 sample questions</p>
              <div v-for="(questionItem, index) in question_items" :key="questionItem.id" style="font-size:16px !important;">
                <label class="qus_label"  v-show="index == questionIndex">{{(index+1)}}. {{questionItem.qus}}</label>
                <v-radio-group   @change="changedRadioButtonActvity($event, questionItem.id) "  v-show="index == questionIndex" class="ma-4"  id="'qus'+index" v-model="questionItem.selected_answer">
                  <v-radio :label="answersItem.ans" :value="answersItem.id"  v-for="answersItem in questionItem.answers"
                  :key="answersItem.id" color="#F19700 !important"></v-radio>
                </v-radio-group>
              </div>
              <span style="color:red"  v-if="ans_error">Answer is required!</span>
            </div>  
          </v-card-text>
          <v-card-actions v-if="questionIndex < 5">
            <v-spacer></v-spacer>
            <v-btn class="blue-border-btn" text v-if="questionIndex > 0" @click="prev()" >Prev</v-btn>
            <v-btn type="submit" style="background-color: #051d42 !important;color: #fff !important;height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;" @click="next(questionIndex)"  
              >Next</v-btn>
          </v-card-actions>
          <v-card-actions v-else>
            <v-spacer></v-spacer>
            <v-btn class="blue-border-btn" text v-if="questionIndex > 0" @click="prev" >Back</v-btn>
            <v-btn type="submit" style="background-color: #051d42 !important;color: #fff !important;height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;" @click="submit(questionIndex)"  
            >Submit</v-btn>
          </v-card-actions>
        </form>  
      </v-card>
    </v-dialog>

    <v-dialog v-model="riskometer_score_dialog" width="868" persistent>
      <v-card class="secure-modal proceed-modal csv-file-modal riskmeter_main">
        <v-card-title class="text-h5" ></v-card-title>
        <v-card-text>
          <v-row>
            <v-col>
              {{memberName}}
            </v-col>
            <v-col>
              <span style="float:right;">As on {{server_curr_date}}</span>
              <v-img max-height="23" max-width="19" :src=" riskometer_icon" :lazy-src="riskometer_icon"> </v-img>
            </v-col>  
          </v-row>  
          <div class="meter_wrapper">
              <div class="meter_text_box">
                <div class="riskmeter-speedometer-img">
                  <vue-speedometer 
                    :width="300"
                    :height="200"
                    :needleHeightRatio="0.5"
                    :value="spikeVal"
                    :currentValueText="riskMeter"
                    currentValueColor="black"
                    :customSegmentLabels='[
                      {
                        text: "",
                        position: "INSIDE",
                        color: "#555",

                      },
                      {
                        text: "",
                        position: "INSIDE",
                        color: "#555",
                      },
                      {
                        text: "",
                        position: "INSIDE",
                        color: "#555",
                        fontSize: "19px",
                      },
                      {
                        text: "",
                        position: "INSIDE",
                        color: "#555",
                      },
                      {
                        text: "",
                        position: "INSIDE",
                        color: "#555",
                      },
                    ]'
                    :segmentColors='["darkgreen", "lightgreen", "#f6c71e", "#f6961e", "red"]'
                    :ringWidth="47"
                    :needleTransitionDuration="3333"
                    needleTransition="easeElastic"
                    needleColor="#05275e"
                    textColor="#555"
                  />
                </div>
                <div class="riskemeter_text_content">
                  <p>Your risk tolerance Score is <b style="color:#1A407D">{{score}}</b>. {{additionalText}}.</p>
                  <p> Your risk tolerance can be viewed in <b>Investometer</b>. Click <b>Proceed</b> below to check risk tolerance for other members or you can click “Investometer” to view your latest Riskometer score.</p>
                </div>
              </div>
              <div class="riskMeter_btn">
                <v-btn type="submit" style="color: #051d42 !important; border-color: 1px solid #051d42 !important; height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;margin-right:12px" @click="proceed('investometer')"  
                >INVESTOMETER</v-btn>
                <v-btn type="submit" style="background-color: #051d42 !important;color: #fff !important;height: 46px !important;font-family: Work Sans, sans-serif;min-width: 200px !important;" @click="proceed('proceed')"  
                >PROCEED</v-btn>
              </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>    
  </div>
</template>

<script>
  import axios from "axios";
  import { Auth } from "aws-amplify";
  import VueSpeedometer from "vue-speedometer";

  export default {
    components: {
      VueSpeedometer
    },  
    data: () => ({
      questionIndex:0,
      value_added_listing: [],
      webIcon: process.env.VUE_APP_ROOT_ICONS_URL,
      item_text : '',
      showMemberError:false,
      goal_sure_info_dialog:false,
      goal_sure_options_dialog:false,
      delete_pic:process.env.VUE_APP_ROOT_ICONS_URL + 'delete-icon.png',
      riskometer_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'riskometer.png',
      protectometer_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'protectometer.png',
      retirometer_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'retirometer.png',
      edumeter_icon:process.env.VUE_APP_ROOT_ICONS_URL + 'edumeter.png',

      goal_sure_options_list:[{'id':1, 'name':'RISKO', 'icon':'riskometer.png', 'text':'Check your risk tolerance level', 'bg':'#3D8AF7'}, {'id':2, 'name':'PROTECTO', 'icon':'protectometer.png', 'text':'Check adequacy of your insurance cover', 'bg':'#E35FE3'}, {'id':3, 'name':'RETIRO', 'icon':'retirometer.png', 'text':'How far away from reaching your retirement income', 'bg':'#CEB871'}, {'id':4, 'name':'EDU', 'icon':'edumeter.png', 'text':'Best education needs diligent planning', 'bg':'#7D7D7D'}],

      goal_sure_quetion_dialog:false,
      member:'',
      member_items:[],

      isMandatory:false,
      error : 'Required',
      question_items :[],
      question_error:'',
      qus_error_str:'Answer required for question no.',
      mandatory:true,
      goal_sure_member_dialog:false,
      ans_error:false,
      ans:'',
      qus:'',
      quiz_arr:[],
      is_ans_empty:true,
      riskometer_score_dialog:false,
      spikeVal:0,
      riskMeter:'Low',
      memberName:'',
      server_curr_date:'',
      score:0,
      additionalText:'',
      isDataAvailable:false
    }),

    created(){
        let id = this.$route.params.id ;
        if(this.$route.params.id  ==0){
             id = this.$route.params.id.toString()
        }
        if(id){
          setTimeout(()=>{this.setIfMemberAllreadyHaveData(id);}, 1000);
          this.isFormValid  = true;
        }
    },

    mounted() {
      this.willData();
      this.appendMemberList();
    },
    methods: {
      appendQuestionList(member_id){
        let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
        let formdata    = new FormData();
        formdata.append("aws_cognito_id", cognito_idp);
        formdata.append("member_id", member_id);
        axios.post(process.env.VUE_APP_ROOT_API + "get-goalsure-question-detail", formdata)
        .then((response) => { 
          this.question_items  = response.data.list;
          this.isDataAvailable = response.data.isDataAvailable;
        });
      },

      appendMemberList(){
        this.member_items = []
        Auth.currentAuthenticatedUser({
          bypassCache: false
        }).then(user => {
          this.main_member_detail = user.attributes;  
          this.user_name = user.attributes["custom:name"];
          this.member_items.push({'id':'0', 'name':this.user_name});
        })

        let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
        let formdata    = new FormData();
        formdata.append("aws_cognito_id", cognito_idp);
        axios.post(process.env.VUE_APP_ROOT_API + "get-family-member-list", formdata)
        .then((response) => {
          this.family_member_list = response.data.data;
          this.family_member_list.forEach(member_detail=>{
            this.member_items.push({id:member_detail.id, name:member_detail.name})
          });
        });
      },

      subcategory(id, text){
        if(id  == 1){
          this.$router.push({ name: "MyWill"}).catch(()=>{});
        }
        else if(id  == 3){
          this.item_text = text;
          this.goal_sure_info_dialog = true;
        }
      },
 
      willData() {
        let cognito_idp = atob(localStorage.getItem("cognito_idp"));
        let formdata = new FormData();
        formdata.append("aws_cognito_id", cognito_idp);
        axios.post(process.env.VUE_APP_ROOT_API + "value-added-listing", formdata, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*",
          },
        })
        .then((response) => {
          this.value_added_listing = response.data.data;
        });
      },

      close(){
        this.goal_sure_info_dialog = false;
      },

      proceedGoalSure(){
        this.goal_sure_options_dialog = true;
      },

      proceedMemeber(){},

      submit(i){
        let questionId = '';
        let answerId   = '';
        if(this.ans =='' && this.isDataAvailable){
          this.question_items.forEach((item,index)=>{
            if(i == index){
              questionId = item.id;
              answerId   = item.selected_answer;
            }
          });
        }
        else{
          questionId = this.qus;
          answerId   = this.ans;
        }
        this.quiz_arr.push({'questionId':questionId, 'answerId':answerId});   
        let cognito_idp =  atob(localStorage.getItem('cognito_idp'));
        let formdata    = new FormData();
        formdata.append("aws_cognito_id", cognito_idp);
        formdata.append("member_id", this.member);
        formdata.append("qus_ans_detail", JSON.stringify(this.quiz_arr));
        axios.post(process.env.VUE_APP_ROOT_API + "post-riskometer", formdata)
        .then((response) => {
          this.spikeVal                = response.data.data.spik_value;
          this.riskMeter               = response.data.data.riskMeter;
          this.server_curr_date        = response.data.data.curr_date;
          this.score                   = response.data.data.score;
          this.additionalText          = response.data.data.additionalText;
          this.riskometer_score_dialog = true;
        });
      },

      changedRadioButtonActvity(e, q){
        this.ans_error    = false;
        this.ans          = e;
        this.qus          = q;
        this.is_ans_empty = false;
      },

      showQuestionCard(){
        if(this.member == ''){
          this.showMemberError = true;
        }
        else{
          this.showMemberError = false;
          this.goal_sure_quetion_dialog = true;
        }
      },

      next(i){
        let questionId = '';
        let answerId   = '';
        if(!this.isDataAvailable && this.is_ans_empty){
          this.ans_error = true;
          return false;
        }

        if(this.ans =='' && this.isDataAvailable){
          this.question_items.forEach((item,index)=>{
            if(i == index){
              questionId = item.id;
              answerId   = item.selected_answer;
            }
          });
        }
        else{
          questionId = this.qus;
          answerId   = this.ans;
        }
        this.ans_error = false;
        this.quiz_arr.push({'questionId':questionId, 'answerId':answerId});   
        this.is_ans_empty = true;
        this.ans = '';
        this.qus = '';
        this.questionIndex++;
      },

      prev(){
        this.ans_error    = false;
        this.is_ans_empty = false;
        this.quiz_arr.pop({'questionId':this.qus, 'answerId':this.ans}); 
        this.questionIndex--;
      },

      chooseMember(e){
        this.appendQuestionList(e);
        this.showMemberError = false;
        this.member_items.forEach(item=>{
          if(e == item.id){
            this.memberName = item.name;
          }
        });
        this.member = e;
      },


      proceed(e){
        if(e == 'investometer'){
          this.$router.push({ name: "Investometer", params: {}}).catch(()=>{});  
        }
        else{
          this.$router.go(0);       
        }
      },

      goalSureMemberDialog(){
        this.$refs.member.reset();
        this.goal_sure_member_dialog=false;
      },

      proceedGoalSureOption(id){
        if(id == 1){
          this.goal_sure_member_dialog = true;
        }
        else if(id ==2){
          this.$router.push({ name: "ProtectoMeterForm", params: {}}).catch(()=>{});
        }
        else if(id ==3){
          this.$router.push({ name: "RetiroMeterForm", params: {}}).catch(()=>{});
        }
        else if(id ==4){
          this.$router.push({ name: "EduMeterForm", params: {}}).catch(()=>{});
        }
        else{
          
        }
      },

      setIfMemberAllreadyHaveData(id){
        this.member = id;
        this.appendQuestionList(id);
        this.goal_sure_member_dialog = true;
      }
    },
  };
</script>
<style scoped>
  .goalSureOptions{
    display:flex;
    flex-wrap:wrap;
    justify-content:space-between;
  }
  .goalSureOptions>div{
    width:46%;
    margin-bottom:10px;
  }
  .qus_label {
    font-size: 16px;
    line-height: 1.2;
    left: 17px;
    position: relative;
    color:#1a407d !important;
  }
  .qus_note{
    margin-left: 19px;
  }
  .riskmeter_main .v-card__text .row {
    background-color: #1A407D;
    color: white;
}

.riskmeter_main  .v-card__title.text-h5 {
    border: 0;
    padding: 0;
}

.riskmeter_main {
    padding-top: 0;
}

.speedometer {
    height: auto !important;
    width: auto !important;
}

.meter_text_box {
    display: flex;
    align-items: center;
    padding:30px 22px 0;
}
.riskMeter_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 50px;
}
.secure-modal.proceed-modal.csv-file-modal.riskmeter_main.v-card.v-sheet.theme--light {
    border: 1px solid #F19700;
}
</style>

